<h1 mat-dialog-title class="p-2 text-center">Ajout d'un contact </h1>
<div mat-dialog-content class="p-3">

    <div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.FirstName" placeholder="Prénom" required>
            </mat-form-field>

            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.LastName" placeholder="Nom" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.Phone" placeholder="Téléphone" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.CompanyName" placeholder="Nom de l'entreprise" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col mb-3">
                <input matInput [(ngModel)]="Model.Email" placeholder="Email" [formControl]="ValidEmail" required>
                @if (!ValidEmail.valid) {
                <mat-error>
                    Email incorrect
                </mat-error>
                }
            </mat-form-field>
        </div>
    </div>


    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>

        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()">
            Ajouter
        </button>
    </div>
</div>